import { ReviewRepository } from "../../repositories/ReviewRepository";

/**
 * Create Review Request Use Case
 * Creates a new review request
 */
export class CreateReviewRequestUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(data: {
    module_code: string;
    action_code: string;
    entity_type: string;
    entity_id: number;
    request_comments?: string;
  }): Promise<{ review_id: number }> {
    if (!data.module_code || data.module_code.trim() === "") {
      throw new Error("Module code is required");
    }

    if (!data.action_code || data.action_code.trim() === "") {
      throw new Error("Action code is required");
    }

    if (!data.entity_type || data.entity_type.trim() === "") {
      throw new Error("Entity type is required");
    }

    if (!data.entity_id || data.entity_id <= 0) {
      throw new Error("Invalid entity ID");
    }

    return await this.repository.createReviewRequest(data);
  }
}
